import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { TreeSelect } from "antd";

import * as actions from "../../actions";
import * as Template from "../../templates";
import { useNavigate, useParams } from "react-router-dom";

export default () => {
  const moduleName = "attribute_categories";
  const appReducer = useSelector(state => state.appReducer, shallowEqual);
  const dispatch = useDispatch();

  const params = useParams()
  
  const navigate = useNavigate()

  const [id, setId] = useState();

  const [productCategories, setProductCategories] = useState(``);
  
  const [name, setName] = useState(``);

  const [categoryId, setCategoryId] = useState(``);

  const [state, setState] = useState(``);

  const [submitted, setSubmitted] = useState(false);

  const onChange = (value) => setCategoryId(value);


  const handleChangeState = (value) => setState(value);
  
  const handleClick = () => {
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
    setSubmitted(true)
  };

  useEffect(() => {
    if (submitted) {
      if (
        (appReducer.attribute_categories_store != undefined && appReducer.attribute_categories_store.error == false) ||
        (appReducer.attribute_categories_update != undefined && appReducer.attribute_categories_update.error == false)
      ) {
        navigate(-1)
      }
    }
    return () => setSubmitted(false)
  }, [
    appReducer.attribute_categories_store,
    appReducer.attribute_categories_update
  ])

  useEffect(() => {
    if (appReducer.attribute_categories_edit != undefined && id != undefined) {
      let row = appReducer.attribute_categories_edit.data;
      setName(row.name);
      setState({
        value: row.state,
        label: row.state == `active` ? `فعال` : `غیرفعال`,
      });
      setCategoryId(row.product_category_id);
    }
  }, [appReducer.attribute_categories_edit]);

  useEffect(() => {
    if (appReducer.product_categories_tree_select_list != undefined) {
      setProductCategories(appReducer.product_categories_tree_select_list);
    }
  }, [appReducer.product_categories_tree_select_list]);

  useEffect(() => {
    if (id != undefined) {
      dispatch(actions.edit(id, moduleName));
    }
    dispatch(actions.list(`product_categories/tree_select`));
  }, [id]);

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])

  return <Template.Form>
    <Template.Input required value={name} label="نام" name="name" type="text" />
    {productCategories != `` && (
      <div className="flex flex-col space-y-3">
        <label className="text-gray-500">انتخاب سرگروه <i className="star">*</i></label>
        <TreeSelect
          treeData={productCategories.data}
          showSearch
          style={{ width: "100%" }}
          value={categoryId}
          dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
          placeholder="انتخاب گروه"
          allowClear
          treeDefaultExpandAll
          onChange={onChange}
        />
        <input
          type="hidden"
          defaultValue={categoryId}
          name="product_category_id"
        />
      </div>
    )}
    <Template.SingleSelect
      withLabel
      required
      placeholder="وضعیت"
      onChange={handleChangeState}
      name="state"
      value={state}
      options={[
        {
          value: "active",
          label: "فعال",
        },
        {
          value: "deactive",
          label: "غیرفعال",
        },
      ]}
    />
    <Template.Button
      label="ذخیره"

      onClick={handleClick}
    />
  </Template.Form>;
};
